import React, { useCallback } from 'react';

import { Col, Row } from '@opendoor/atoms/box';
import { Text } from '@opendoor/atoms/text';
import { Navigate, useParams } from 'react-router';

import { Divider } from '../../components/Divider';
import { Layout } from '../../components/Layout';
import { SidebarNav, SidebarNavItem } from '../../components/SidebarNav';
import { Tabs } from './TabRoutes';

const BASE_PATH = '/developer';
export const DEVELOPER_DASHBOARD_NAME = 'developer dashboard';

const renderLogo = () => (
  <Row>
    <img
      src="https://images.opendoor.com/source/s3/imgdrop-production/065e19554f80403eaa59d45a859d2df2.png?service=partnership-dashboard-fe"
      alt="Opendoor"
      height="25"
      // Preflight's `img { height: auto }` outranks the `height` attribute,
      // so the intended size has to be restated as a style.
      style={{ height: 25 }}
    />
  </Row>
);

const DeveloperDashboard: React.FC<{ testMode?: boolean }> = () => {
  const { tab } = useParams<{ tab?: string }>();

  const renderRoutes = useCallback(() => {
    const activeTab = Tabs.find((t) => t.path === tab);
    if (!activeTab) {
      return <Navigate to={`${BASE_PATH}/${Tabs[0].path}`} replace />;
    }

    return <activeTab.component />;
  }, [tab]);

  const renderSidebar = useCallback(() => {
    // Use fallback for sidebar highlighting during redirect
    const activeTabPath = tab || Tabs[0].path;
    const navBarItems: Array<SidebarNavItem> = Tabs.map((tabConfig) => ({
      icon: tabConfig.icon,
      isActive: activeTabPath === tabConfig.path,
      link: `${BASE_PATH}${tabConfig.link}`,
      name: tabConfig.name,
      isDisabled: tabConfig.isDisabled,
    }));

    return (
      <div>
        <SidebarNav navBarItems={navBarItems} />
        <Col className="py-6">
          <Divider />
        </Col>
        <Col className="pl-8">
          <Text as="p" className="text-label-sm py-1">
            Questions or feedback?
          </Text>
          <Text as="p" className="text-body-md">
            <a href="mailto:partnerships-epd@opendoor.com">Email us</a>
          </Text>
        </Col>
      </div>
    );
  }, [tab]);

  return <Layout renderLogo={renderLogo} renderNav={renderSidebar} renderContent={renderRoutes} />;
};

export default DeveloperDashboard;
